export default __webpack_public_path__ + "static/tablet_KV11-7633af4cf6829ef7247bf7bc25e91e28.mp4";